import { render, staticRenderFns } from "./goodspackage_total_report.vue?vue&type=template&id=3373517b&scoped=true"
import script from "./goodspackage_total_report.vue?vue&type=script&lang=js"
export * from "./goodspackage_total_report.vue?vue&type=script&lang=js"
import style0 from "./goodspackage_total_report.vue?vue&type=style&index=0&id=3373517b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373517b",
  null
  
)

export default component.exports